document.addEventListener('change', event => {
  if (event.target.id !== 'VariantSelect') return;
  const option = event.target.selectedOptions[0];
  const root = event.target.closest('[data-product-section]');
  if (!root || !option) return;
  root.querySelectorAll('[data-product-price]').forEach(el => { el.textContent = option.dataset.price; });
  root.querySelectorAll('[data-compare-price]').forEach(el => { el.textContent = option.dataset.compare || ''; el.hidden = !option.dataset.compare; });
  root.querySelectorAll('[data-add-button]').forEach(button => {
    button.disabled = option.dataset.available !== 'true';
    button.textContent = button.disabled ? button.dataset.sold : button.dataset.label;
  });
  const url = new URL(location.href);
  url.searchParams.set('variant', option.value);
  history.replaceState({}, '', url);
  const media = document.getElementById('media-' + option.dataset.media);
  if (media) {
    if (matchMedia('(max-width: 760px)').matches) media.scrollIntoView({block:'nearest',inline:'center',behavior:'smooth'});
    else media.parentElement.prepend(media);
  }
});
document.addEventListener('keydown', event => {
  if (event.key === 'Escape') document.querySelectorAll('.nl-mobile-menu[open], .nl-filter[open]').forEach(el => { el.open = false; el.querySelector('summary')?.focus(); });
});
document.addEventListener('click', event => {
  document.querySelectorAll('.nl-filter[open]').forEach(el => { if (!el.contains(event.target)) el.open = false; });
});
